import * as t from './actionTypes';

export const setAirline = (airline, triggeredByEnter) => ({
  type: t.SET_AIRLINE,
  airline,
  secondarySearchAction: triggeredByEnter,
  secondaryAdvancedSearchAction: triggeredByEnter,
});

export const setArrivalAirport = (arrivalAirport, triggeredByEnter) => ({
  type: t.SET_ARRIVAL_AIRPORT,
  arrivalAirport,
  secondaryAdvancedSearchAction: triggeredByEnter,
});

export const setDepartureAirport = (departureAirport, triggeredByEnter) => ({
  type: t.SET_DEPARTURE_AIRPORT,
  departureAirport,
  secondaryAdvancedSearchAction: triggeredByEnter,
});

export const setDepartureDate = (departureDate, triggeredByEnter) => ({
  type: t.SET_DEPARTURE_DATE,
  departureDate,
  secondaryAdvancedSearchAction: triggeredByEnter,
});

export const setDepartureTime = (departureTime, triggeredByEnter) => ({
  type: t.SET_DEPARTURE_TIME,
  departureTime,
  secondaryAdvancedSearchAction: triggeredByEnter,
});

export const setFlightNumber = flightNumber => ({
  type: t.SET_FLIGHT_NUMBER,
  flightNumber,
});

export const setFlightTrackerSearchError = errorCode => ({
  type: t.SET_FLIGHT_TRACKER_SEARCH_ERROR,
  errorCode,
});

export const setRandomFlightPath = randomFlightPath => ({
  type: t.SET_RANDOM_FLIGHT_PATH,
  randomFlightPath,
});

export const setUniversalSearchFlight = universalSearchFlight => ({
  type: t.SET_UNIVERSAL_SEARCH_FLIGHT,
  universalSearchFlight,
});

export const setAdvancedSearchUrl = url => ({
  type: t.SET_ADVANCED_SEARCH_URL,
  data: {
    url,
  },
});

export const setFlightTrackerQueryError = o => ({
  type: t.SET_FLIGHT_TRACKER_QUERY_ERROR,
  data: {
    error: o.error,
  },
});

export const setSecondarySearchAction = bool => ({
  type: t.SET_SECONDARY_SEARCH_ACTION,
  bool,
});

export const setSecondaryAdvancedSearchAction = bool => ({
  type: t.SET_SECONDARY_ADVANCED_SEARCH_ACTION,
  bool,
});

export const setSecondaryAdvancedSearchActionAirline = bool => ({
  type: t.SET_SECONDARY_AIRLINE,
  bool,
});

export const setSecondaryAdvancedSearchActionDepAirport = bool => ({
  type: t.SET_SECONDARY_DEP_AIRPORT,
  bool,
});

export const setSecondaryAdvancedSearchActionArrAirport = bool => ({
  type: t.SET_SECONDARY_ARR_AIRPORT,
  bool,
});

export const setSecondaryAdvancedSearchActionDepDate = bool => ({
  type: t.SET_SECONDARY_DEP_DATE,
  bool,
});

export const setSecondaryAdvancedSearchActionTime = bool => ({
  type: t.SET_SECONDARY_TIME,
  bool,
});

export const setAllAdvancedSearchAsyncBools = bool => ({
  type: t.SET_SECONDARY_ALL_BOOL,
  bool,
});

export const updatingFlightNumberInput = bool => ({
  type: t.UPDATING_FLIGHT_NUMBER_INPUT,
  bool,
});



// WEBPACK FOOTER //
// ./modules/FlightTracker/redux/Search/actions.js